export const environment = {
  production: false,
  urlApi: 'https://portal-api.wba.com.br',
  urlWS: 'https://new-api.wba.com.br/ws',
  keycloak: {
    url: 'https://auth.wba.com.br',
    realm: 'portal',
    clientId: 'portal-angular'
  },
  gAnalytics: '203092816',
};